import { useState } from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";
import AddItem from "../../../../../../shared/components/features/addItem/AddItem"
import CreateStudyGroupFlowWizard from "../../../../../features/createStudyGroup/createStudyGroupFlowWizard/CreateStudyGroupFlowWizard";
import iconsList from "../../../../../../shared/components/ui/icons/iconsList";
import classes from "./AddStudyGroupFromNmm.module.css";

const AddStudyGroupFromNmm = () => {

    const { studyGroupId } = useParams();
    const { texts } = useSelector(state => state.translate)
    const [createStudyGroup, setCreateStudyGroup] = useState(false);

    return (
        <>
            <AddItem className={classes.AddStudyGroupFromNmm} icon={iconsList.addCircle} onClick={() => setCreateStudyGroup(true)} text={texts.addStudyGroup} />
            {createStudyGroup &&
                <CreateStudyGroupFlowWizard studyGroupId={studyGroupId} onClose={() => setCreateStudyGroup(false)} />
            }
        </>
    )
}
export default AddStudyGroupFromNmm